module.exports = __webpack_public_path__ + "static/media/PhysicalActivityRecommendationsDuringaPandemic.03068426.png";